/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_CutInputs */



/**
* | output |
* | --- |
* | "Cut" |
*
* @param {Context_Menu_CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_cut = /** @type {((inputs?: Context_Menu_CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couper")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schneiden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Резать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cortar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("काटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corte")
	return /** @type {LocalizedString} */ ("Cut")
});